module.exports = __webpack_public_path__ + "img/已定位_local-2.70cc49f9.svg";